import { letterSoundLevels } from "./letter-sound";
import { pictureWordMatchLevels } from "./picture-word-match";
import { rhythmPhraseLevels } from "./rhythm-phrases";
import type { EnglishLevel } from "./types";

export { letterSoundLevels } from "./letter-sound";
export { pictureWordMatchLevels } from "./picture-word-match";
export { rhythmPhraseLevels } from "./rhythm-phrases";
export * from "./types";

export const englishLevels: EnglishLevel[] = [
  ...letterSoundLevels,
  ...pictureWordMatchLevels,
  ...rhythmPhraseLevels
];
